export default class Carousel {
    constructor(breakpoints = {
        md: 768,
        xl: 1280
    }) {
        this.breakpoints = breakpoints
        this.main()
    }
    main() {
        // Slick -- 插件調用
        $('.carousel-box .carousel-list').each(function () {
            $(this).slick({
                lazyLoad: 'progressive',
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 3000,
                infinite: true,
                autoplay: true,
                waitForAnimate: false, //  不等待animate执行结束
                dots: true,
                prevArrow: $(this).parents('.carousel-box').find('.slick-prev'),
                nextArrow: $(this).parents('.carousel-box').find('.slick-next'),
            });

            $(window).on('resize orientationchange', () => {
                $(this).slick('resize');
            });
        });
    }
}